import React from "react";
import { PopoverProps } from "../types";

export const PopoverContext = React.createContext<PopoverProps>({});
